import { useTranslation } from "react-i18next";

export const formatAgentFilteredPoliciesForDashboard = (policies) => {
  return [
    {
      banner: "",
      badgeStatus: "good",
      badgeSrText: "",
      badgeText: "",
      title: "All",
      type: "all",
      number: (() => {
        let sumOfPolicies = 0;
        for (let policyKey in policies) {
          if (policies[policyKey].length)
            sumOfPolicies += policies[policyKey].length;
        }
        return sumOfPolicies;
      })(),
      actionNeeded: true,
      policies: policies,
    },
    {
      banner: "",
      badgeStatus: "good",
      badgeSrText: "",
      badgeText: "",
      title: "In Force",
      type: "inforce",
      number: policies?.inForcePolicies?.length ?? 0,
      actionNeeded: true,
      policies: policies?.inForcePolicies,
    },
    {
      banner: "risk",
      badgeStatus: "risk",
      badgeSrText: "",
      badgeText: "",
      title: "In Grace",
      type: "ingrace",
      number: policies?.inGracePolicies?.length ?? 0,
      actionNeeded: true,
      exportAction: true,
      exportTitle: "Export",
      policies: policies?.inGracePolicies,
    },
    {
      banner: "problem",
      badgeStatus: "problem",
      badgeSrText: "",
      badgeText: "",
      title: "Lapsed",
      type: "lapsed",
      number: policies?.lapsedPolicies?.length ?? 0,
      actionNeeded: true,
      exportAction: true,
      exportTitle: "Export",
      policies: policies?.lapsedPolicies,
    },
    {
      banner: "",
      badgeStatus: "information",
      badgeSrText: "",
      badgeText: "",
      title: "Reinstated",
      type: "reinstated",
      number: policies?.reinstatedPolicies?.length ?? 0,
      actionNeeded: true,
      policies: policies?.reinstatedPolicies,
    },
    {
      banner: "",
      badgeStatus: "problem",
      badgeSrText: "",
      badgeText: "",
      title: "Inactive",
      type: "inactive",
      number: policies?.inactivePolicies?.length ?? 0,
      actionNeeded: true,
      actionURL: "/",
      policies: policies?.inactivePolicies,
    },
  ];
};

export const useAgentDashboardQuickLinks = () => {
  const { t } = useTranslation();
  return [
    {
      name: t("AgentDashboardQuickLinks-link1-name"),
      route: t("AgentDashboardQuickLinks-link1-route"),
      icon: t("AgentDashboardQuickLinks-link1-icon"),
    },
    {
      name: t("AgentDashboardQuickLinks-link2-name"),
      route: t("AgentDashboardQuickLinks-link2-route"),
      icon: t("AgentDashboardQuickLinks-link2-icon"),
    },
    {
      name: t("AgentDashboardQuickLinks-link3-name"),
      route: t("AgentDashboardQuickLinks-link3-route"),
      icon: t("AgentDashboardQuickLinks-link3-icon"),
    },
    {
      name: t("AgentDashboardQuickLinks-link4-name"),
      route: t("AgentDashboardQuickLinks-link4-route"),
      icon: t("AgentDashboardQuickLinks-link4-icon"),
    },
    {
      name: t("AgentDashboardQuickLinks-link5-name"),
      route: t("AgentDashboardQuickLinks-link5-route"),
      icon: t("AgentDashboardQuickLinks-link5-icon"),
    },
  ];
};
